import React, { useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";

const Main = () => {
  const [index, setIndex] = useState(0);
  const onChange = (idx) => {
    setIndex(idx);
  };
  return (
    <div className="content_wrap">
      <div className="content">
        <Carousel
          interval={5000}
          showThumbs={false}
          onChange={onChange}
          autoPlay
          emulateTouch
          infiniteLoop
          showStatus={false}
        >
          <div className="rollingContent">
            {index === 0 && (
              <div className="contentImage01">
                <div className="contentImage01-txt01">
                  <img
                    src={require("../images/rolling01-txt01.png")}
                    alt="rolling01-txt01"
                  />
                </div>
                <div className="contentImage01-txt02">
                  <img
                    src={require("../images/rolling01-txt02.png")}
                    alt="rolling01-txt02"
                  />
                </div>
                <div className="contentImage01-txt03">
                  <img
                    src={require("../images/rolling01-txt03.png")}
                    alt="rolling01-txt03"
                  />
                </div>
              </div>
            )}
          </div>
          {/* <div className="rollingContent">
            {index === 1 &&
            <div className="contentImage02">
              <div className="contentImage02-txt01"><img src={require('../images/rolling02-txt01.png')} alt="rolling02-txt01"/></div>
              <div className="contentImage02-txt02"><img src={require('../images/rolling02-txt02.png')} alt="rolling02-txt02"/></div>
              <div className="contentImage02-img"><img src={require('../images/rolling02-1.png')} alt="rolling02-1"/></div>
              <div className="contentImage02-img2"><img src={require('../images/rolling02-3.png')} alt="rolling02-3" /></div>
              <div className="contentImage02-img3"><img src={require('../images/rolling02-4.png')} alt="rolling02-4" /></div>
            </div>
            }
          </div> */}
          <div className="rollingContent">
            {index === 1 && (
              <div className="contentImage03">
                <div className="contentImage03-txt01">
                  <img
                    src={require("../images/rolling03-txt01.png")}
                    alt="rolling03-txt01"
                  />
                </div>
                <div className="contentImage03-txt02">
                  <img
                    src={require("../images/rolling03-txt02.png")}
                    alt="rolling03-txt02"
                  />
                </div>
                <div className="contentImage03-txt03">
                  <img
                    src={require("../images/rolling03-txt03.png")}
                    alt="rolling03-txt03"
                  />
                </div>
              </div>
            )}
          </div>
        </Carousel>
      </div>
    </div>
  );
};

export default Main;
